import { createCustomEnum } from "./customEnum";

export type TerminalSolutionStatusKeys =
	| "Updated"
	| "Complete"
	| "Draft"
	| "Closed"
	| "Pending";

const TsStatusValues = createCustomEnum({
	Updated: { name: "updated", value: "updated", displayName: "Updated" },
	Complete: { name: "complete", value: "complete", displayName: "Complete" },
	Closed: { name: "closed", value: "closed", displayName: "Closed" },
	Draft: { name: "draft", value: "draft", displayName: "Draft" },
	Pending: { name: "pending", value: "pending", displayName: "Pending" },
});

export default TsStatusValues;
